import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import { container } from '../../../assets/material-kit-react'
import CustomTabs from '../../../components/CustomTabs'
// import Card from "../../../components/Card/Card";
import UnitDetail from './UnitDetail'
import {
    STUDIO_DESC,
    STUDIO_IMAGE,
    ONE_BED_ROOM_DESC,
    ONE_BR_IMAGE,
    TWO_BED_ROOM_DESC,
    TWO_BR_IMAGE,
    THREE_BED_ROOM_DESC,
    THREE_BR_IMAGE,
    UNIT_VR_LINKS
} from '../../../utils/Constants'
import vr_image from '../../../images/vr_image.jpg'

import * as Sentry from '@sentry/browser'

Sentry.init({
    dsn: "https://a2a837fdcc7047ee8369a55e2f144948@sentry.io/1337446"
});

class Units extends Component {

    constructor(props) {
        super(props)

        this.state = {
            position: 0,
            width: 0,
        }
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth });
    }

    componentDidCatch(error, errorInfo) {

        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });

    }

    render() {

        const { classes } = this.props
        const { position } = this.state

        const vr_link = UNIT_VR_LINKS[position]

        return (
            <div className={classes.sections}>

                <div className={classes.container}>

                    <CustomTabs
                        headerColor="info"
                        tabs={[
                            {
                                tabName: "Studio",
                                tabContent: (
                                    <UnitDetail
                                        room_desc={STUDIO_DESC}
                                        images={STUDIO_IMAGE}
                                        type={0} />
                                )
                            },
                            {
                                tabName: "1 Bed Room",
                                tabContent: (
                                    <UnitDetail
                                        room_desc={ONE_BED_ROOM_DESC}
                                        images={ONE_BR_IMAGE}
                                        type={1} />
                                )
                            },
                            {
                                tabName: "2 Bed Room",
                                tabContent: (
                                    <UnitDetail
                                        room_desc={TWO_BED_ROOM_DESC}
                                        images={TWO_BR_IMAGE}
                                        type={2} />
                                )
                            },
                            {
                                tabName: "3 Bed Room",
                                tabContent: (
                                    <UnitDetail
                                        room_desc={THREE_BED_ROOM_DESC}
                                        images={THREE_BR_IMAGE}
                                        type={3} />
                                )
                            }
                        ]}
                        onTabClick={this.handleTabClick}
                    />

                </div>

                <div style={{ width: "100%", textAlign: "center" }} >
                    <a href={vr_link} target="_blank" rel='noreferrer noopener'>
                        <img
                            src={vr_image}
                            alt="VR"
                            width={this.state.width < 1500 && this.state.width}
                        />
                    </a>
                </div>

                {/* <iframe
                    title="room"
                    width='100%'
                    height='700'
                    src={vr_link}

                    allow='vr'
                /> */}

                <footer>
                    <img src={require('../../../images/CityLoftFrame.svg')} alt="Frame" />
                </footer>


            </div>

        )
    }

    handleTabClick = (position) => {
        this.setState({
            position
        })
    }

}


const styles = theme => ({
    sections: {
        flex: 1,
        minHeight: '100vh',
    },
    container: {
        ...container,
        padding: '20px 20px 0px 0px'
    },

})


Units.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Units)
